import ModalDeleteCourse from "./ModalDeleteCourse";
import ModalDescription from "./ModalDescription";
import ModalDuplicateSalary from "./ModalDuplicateSalary";
import ModalEditEndJob from "./ModalEditEndJob";
import ModalCourseForm from "./ModalNewCourseForm";

export {
  ModalDeleteCourse,
  ModalCourseForm,
  ModalEditEndJob,
  ModalDescription,
  ModalDuplicateSalary
};
